export function addBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.child.map((child, i) => {
    if (child.current != null && child.current?.child.current?.props.sectionName === 'SubJobDirectionTemplate') {
      child.current?.setState({ showModal: true, componentType: 'Create' });
    }
  })
}
